{
  "it": {
    "login": {
      "acceptTos": "termini e condizioni",
      "acceptTosPrefix": "Accetto i ",
      "acceptTosRequired": "È necessario accettare i termini e condizioni per creare un account.",
      "auth-ziggu/invalid-invitation-code": "Verifichi con la persona che gliel'ha condiviso se è disponibile un nuovo link. Se ha già un account, effettui l'accesso.",
      "auth-ziggu/user-created": "Il Suo account utente è stato creato 🎉 La stiamo facendo accedere, un momento…",
      "auth/invalid-action-code": "Per motivi di sicurezza, i link per il reset della password scadono dopo poco tempo. Se ha ancora bisogno di reimpostare la password, può richiedere una nuova email di reset.",
      "auth/invalid-credential": "La password non è valida per l'indirizzo email indicato, oppure non esiste un account per questa email.",
      "auth/invalid-email": "L'indirizzo email non è valido.",
      "auth/network-request-failed": "Si è verificato un errore di rete. Verifichi la connessione e riprovi.",
      "auth/too-many-requests": "Troppe richieste, riprovi più tardi.",
      "backToLogin": "Torna all'accesso",
      "cookiePolicy": "Informativa sui cookie",
      "emailAddress": "Indirizzo email",
      "emailAddressInvalid": "Indirizzo email non valido",
      "emailAddressRequired": "L'indirizzo email è obbligatorio",
      "googleLogin": "Accedi con Google",
      "notification_error_no_access": "Il Suo account non dispone dell'accesso.",
      "notification_error_session_expired": "La sessione è scaduta, effettui nuovamente l'accesso.",
      "notification_success_logout": "Si è disconnesso dal Suo account.",
      "notification_success_profile_transfer": "Il Suo indirizzo email è stato modificato. Acceda con il nuovo indirizzo email e la password associata.",
      "password": "Password",
      "passwordConfirmMatchRequired": "La conferma della password non corrisponde",
      "passwordConfirmRequired": "La conferma della password è obbligatoria",
      "passwordForgot": "Password dimenticata?",
      "passwordLengthRequired": "La password deve contenere almeno 8 caratteri",
      "passwordRequired": "La password è obbligatoria",
      "password_confirm": "Conferma password",
      "privacyPolicy": "Informativa sulla privacy",
      "submit_expired_reset": "Richiedi un nuovo reset password",
      "submit_expired_signup": "Torna all'accesso",
      "submit_login": "Accedi",
      "submit_password_forgot": "Richiedi reset password",
      "submit_password_reset": "Reimposta password",
      "submit_signup": "Crea account",
      "success_password_forgot": "Se ha un account attivo, le è stata inviata un'email per il reset della password a {email}. Controlli la Sua casella di posta, il link per il reset della password scade tra 1 ora.",
      "success_password_reset": "Reset della password riuscito, accesso in corso…",
      "termsandconditionsPolicy": "Termini e condizioni",
      "title_expired_reset": "Ops, questo link è scaduto…",
      "title_expired_signup": "Questo link di invito non è più attivo",
      "title_login": "Bentornato",
      "title_password_forgot": "Password dimenticata?",
      "title_password_reset": "Reimpostazione della password",
      "title_signup": "Completi la registrazione"
    }
  }
}
